export const PROVEEDORES_REQUEST = "PROVEEDORES_REQUEST";
export const PROVEEDORES_OK = "PROVEEDORES_OK";
export const PROVEEDORES_REFRESH = "PROVEEDORES_REFRESH";
export const PROVEEDORES_ERROR = "PROVEEDORES_ERROR";
